export default __webpack_public_path__ + "static/media/_DSC0331.8bdb06aa.JPG";